import * as React from 'react'

import { TIMEFRAME } from '../../main/constants'
import { useChartLayoutGlobalModel, useModelState } from '../charts-lib'

export function getChartLayoutSizeConfig(
  p = TIMEFRAME.d,
  layoutConfig?: Pick<typeof window.globalChartConfig, 'idea' | 'barWidth' | 'barMargin'>
) {
  let width = 990
  let barWidth = 3
  let barMargin = 1

  switch (p) {
    case TIMEFRAME.i1:
      width = 1523 + 90 * 3
      barWidth = 1
      barMargin = 0
      break
    case TIMEFRAME.i3:
      width = 1043 + (90 / 3) * 6
      break
    case TIMEFRAME.i5:
      width = 947 + (90 / 5) * 9
      barWidth = 5
      barMargin = 2
      break
    case TIMEFRAME.i10:
      width = 1058 // 39bars per day * 5days * 5px per bar + 35px left offset + 48px right offset
      barWidth = 3
      barMargin = 0
      break
    case TIMEFRAME.i15:
      width = 865
      break
    case TIMEFRAME.i30:
      width = 865
      break
    case TIMEFRAME.h:
    case TIMEFRAME.h2:
    case TIMEFRAME.h4:
      width = 924
      break
    case TIMEFRAME.d:
      width = 1282
      break
    case TIMEFRAME.w:
    case TIMEFRAME.m:
      width = 994
      break
  }

  if (document.documentElement.clientWidth <= width) {
    width = 994
    if (p === TIMEFRAME.d) {
      barWidth = 2
      barMargin = 0
      width = 991
    }
  }

  if (layoutConfig?.idea) {
    barWidth = layoutConfig.barWidth
    barMargin = layoutConfig.barMargin
  }

  return {
    width,
    barWidth,
    barMargin,
  }
}

export function useChartLayoutWidthWatch() {
  const { chartLayoutModel } = useChartLayoutGlobalModel()
  const unwatchedFirstChart = React.useMemo(() => chartLayoutModel?.charts().all()[0] ?? null, [chartLayoutModel])
  const chartModel = useModelState(unwatchedFirstChart, { watchProperties: ['quote'] })
  const quote = useModelState(chartModel?.quote() ?? null, { watchProperties: ['ticker', 'timeframe', 'isFetching'] })
  const ideaId = chartLayoutModel?.idea?.id

  React.useEffect(() => {
    const settings = !ideaId ? chartLayoutModel?.settings : null
    const timeframe = quote?.timeframe
    if (timeframe && settings) {
      const { width, barWidth, barMargin } = getChartLayoutSizeConfig(timeframe)
      settings.ChartSettings.center.barWidth = barWidth
      settings.IndicatorSettings.center.barWidth = barWidth
      settings.ChartSettings.center.barMargin = barMargin
      settings.IndicatorSettings.center.barMargin = barMargin

      chartLayoutModel.updateAttributes({ width, settings })
    }
    // We don't want to trigger this effect on any chartLayoutModel change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quote?.timeframe, ideaId])
}
